// Links used in roadmap blocks

export const getItemLink = (name, toolsPaths) => {
  switch (name) {
    case 'idea':
      return toolsPaths.igideaidea;
    case 'products':
      return toolsPaths.igmvp;
    case 'ceo':
      return toolsPaths.ceo_dashboard;
    case 'business':
      return toolsPaths.business_dashboard;
    case 'infrastructure':
      return toolsPaths.igteam;
    case 'startup':
      return toolsPaths.startup;
    case 'customers':
      return toolsPaths.customers;
    case 'homer':
      return toolsPaths.homer;
    case 'gravitas':
      return toolsPaths.gravitas;
    default:
      return null;
  }
};

const TOOLS = {
  IGMVP: 'igmvp',
  IGPRODUCTS: 'igproducts',
  IGBMC: 'igbmc',
  IGSTARTUP: 'igstartup',
  IGFINANCES: 'igfinances',
  IGSUPPORT: 'igsupport',
  IGCEO: 'igceo',
  CEO_DASHBOARD: 'ceo_dashboard',
  MY_TASKS: 'mytasks',
  OUR_SUPPORT: 'oursupport',
  OUR_PRIORITIES: 'ourpriorities',
  OUR_TASKS: 'ourtasks',
  IGWEB: 'igweb',
  IGBUSINESS: 'igbusiness',
  IGTASKS: 'igtasks',
  IGCAPITAL: 'igcapital',
  IGMEETINGS: 'igmeetings',
  IGAFFILIATION: 'igaffiliation',
  IGTEAM: 'igteam',
  IGBOARD: 'igboard',
  IGIDEA_IDEA: 'igideaidea',
  IGIDEA_PERSONAS: 'igideapersonas',
  IGIDEA_CIRCUMSTANCES: 'igideacircumstances',
  IGIDEA_PRODUCT: 'igideaproduct',
  IGIDEA_RESOURCES: 'igidearesources',
  INFRASTRUCTURE_BUILD: 'infrastructure_build',
  IGINFRASTRUCTURE: 'iginfrastructure',
  IGCUSTOMERS: 'igcustomers',
  MONETIZATION_BUILD: 'monetization_build',
  EXECUTION: 'execution',
  TOC: 'toc',
  C_RELATIONS_BUILD: 'c_relations_build',
  MY_ORGANIZATIONS: 'my_organizations',
  MY_PROFILE: 'my_profile',
  PITCH_EDIT: 'edit_igpitch',
  PITCH_PREVIEW: 'igpitch',
  STARTUP_EDIT: 'igstartup_edit',
  IGWEB_EDIT: 'igweb_edit',
  IGAUTHORIZATION: 'igauthorization',
  IG_CURRENT_MODEL: 'ig_current_model',
  VISION: 'vision_bmc'
};

const TOOLS_DATA = {
  IG_CURRENT_MODEL: {
    name: TOOLS.IG_CURRENT_MODEL,
    icon: 'fa fa-flag'
  },
  IGMVP: {
    name: TOOLS.IGMVP,
    icon: 'fa fa-wrench'
  },
  IGPRODUCTS: {
    name: 'igproducts',
    icon: 'fa fa-gift'
  },
  IGBMC: {
    name: 'igbmc',
    icon: 'fa fa-map'
  },
  IGSTARTUP: {
    name: 'igstartup',
    icon: 'fa fa-rocket'
  },
  IGFINANCES: {
    name: 'igfinances',
    icon: 'fa fa-line-chart'
  },
  IGSUPPORT: {
    name: 'igsupport',
    icon: 'fa fa-commenting'
  },
  IGCEO: {
    name: 'igceo',
    icon: 'fa fa-briefcase'
  },
  MY_TASKS: {
    name: 'mytasks',
    icon: 'fa fa-th-list'
  },
  OUR_SUPPORT: {
    name: 'oursupport',
    icon: 'fa fa-commenting'
  },
  OUR_PRIORITIES: {
    name: 'ourpriorities',
    icon: 'fa fa-bomb'
  },
  OUR_TASKS: {
    name: 'ourtasks',
    icon: 'fa fa-list-alt'
  },
  IGWEB: {
    name: 'igweb',
    icon: 'fa fa-globe'
  },
  IGBUSINESS: {
    name: 'igbusiness',
    icon: 'fa fa-compass'
  },
  IGTASKS: {
    name: 'igtasks',
    icon: 'fa fa-th-list'
  },
  IGCAPITAL: {
    name: 'igcapital',
    icon: 'fa fa-pie-chart'
  },
  IGMEETINGS: {
    name: 'igmeetings',
    icon: 'fa fa-phone'
  },
  IGAFFILIATION: {
    name: 'igaffiliation',
    icon: 'fa fa-user-plus'
  },
  IGTEAM: {
    name: 'igteam',
    icon: 'fa fa-group'
  },
  IGBOARD: {
    name: 'igboard',
    icon: 'fa fa-handshake-o'
  },
  IGIDEA_IDEA: {
    name: 'igideaidea',
    icon: 'fa fa-magic'
  },
  IGIDEA_PERSONAS: {
    name: 'igideapersonas',
    icon: 'fa fa-user-circle-o'
  },
  IGIDEA_CIRCUMSTANCES: {
    name: 'igideacircumstances',
    icon: 'fa fa-street-view'
  },
  IGIDEA_PRODUCT: {
    name: 'igideaproduct',
    icon: 'fa fa-gift'
  },
  IGIDEA_RESOURCES: {
    name: 'igidearesources',
    icon: 'fa fa-th'
  },
  INFRASTRUCTURE_BUILD: {
    name: 'infrastructure_build',
    icon: 'fa fa-university'
  },
  IGINFRASTRUCTURE: {
    name: 'iginfrastructure',
    icon: 'fa fa-university'
  },
  MONETIZATION_BUILD: {
    name: 'monetization_build',
    icon: 'fa fa-usd'
  },
  C_RELATIONS_BUILD: {
    name: 'c_relations_build',
    icon: 'fa fa-user'
  },
  IGCUSTOMERS: {
    name: 'igcustomers',
    icon: 'fa fa-user'
  },
  MY_ORGANIZATIONS: {
    name: 'my_organizations',
    icon: ''
  },
  MY_PROFILE: {
    name: 'my_profile',
    icon: ''
  },
  PITCH_EDIT: {
    name: 'edit_igpitch',
    icon: 'fa fa-pencil'
  },
  PITCH_PREVIEW: {
    name: 'igpitch',
    icon: 'fa fa-bullhorn'
  },
  EXECUTION: {
    name: 'execution',
    icon: 'fa fa-th-list'
  },
  CEO_DASHBOARD: {
    name: 'ceo_dashboard',
    icon: 'fa fa-briefcase'
  },
  STARTUP_EDIT: {
    name: 'igstartup_edit',
    icon: 'fa fa-pencil'
  },
  IGWEB_EDIT: {
    name: 'igweb_edit',
    icon: 'fa fa-pencil'
  },
  IGAUTHORIZATION: {
    name: 'igauthorization',
    icon: 'fa fa-lock'
  },
  TOC: {
    name: 'toc',
    icon: 'fa fa-train'
  }
};

const SECTIONS = {
  IDEA: 'idea',
  PRODUCTS: 'products',
  EXECUTION: 'execution',
  CEO: 'ceo',
  BUSINESS: 'business',
  INFRASTRUCTURE: 'infrastructure',
  STARTUP: 'startup',
  CUSTOMERS: 'customers'
};

const BASE_SECTIONS_DATA = new Map([
  [
    'IDEA',
    {
      name: 'idea',
      icon: 'fa fa-lightbulb-o',
      tourDir: 'right',
      borderTop: '1',
      tools: [
        TOOLS_DATA.IGIDEA_IDEA,
        TOOLS_DATA.IGIDEA_PERSONAS,
        TOOLS_DATA.IGIDEA_CIRCUMSTANCES,
        TOOLS_DATA.IGIDEA_PRODUCT,
        TOOLS_DATA.IGIDEA_RESOURCES
      ]
    }
  ],
  [
    'BUSINESS',
    {
      name: 'business',
      icon: 'fa fa-money',
      tourDir: 'bottom',
      borderTop: '5',
      tools: [
        TOOLS_DATA.IG_CURRENT_MODEL,
        { ...TOOLS_DATA.IGBUSINESS, prefix: 'business_' },
        TOOLS_DATA.IGBMC
        // TOOLS_DATA.C_RELATIONS_BUILD,
        // TOOLS_DATA.MONETIZATION_BUILD,
        // TOOLS_DATA.INFRASTRUCTURE_BUILD,
      ]
    }
  ],
  [
    'PRODUCTS',
    {
      name: 'products',
      icon: 'fa fa-gift',
      tourDir: 'bottom',
      borderTop: '2',
      tools: [
        TOOLS_DATA.IGMVP,
        TOOLS_DATA.EXECUTION,
        { ...TOOLS_DATA.IGBUSINESS, prefix: 'product_' },
        TOOLS_DATA.IGSUPPORT,
        TOOLS_DATA.IGPRODUCTS
        // TOOLS_DATA.OUR_TASKS
        // TOOLS_DATA.OUR_SUPPORT
      ]
    }
  ],
  [
    'CEO',
    {
      name: 'ceo',
      icon: 'fa fa-briefcase',
      tourDir: 'right',
      borderTop: '3',
      tools: [
        TOOLS_DATA.CEO_DASHBOARD,
        TOOLS_DATA.IGFINANCES,
        TOOLS_DATA.IGCAPITAL
        // TOOLS_DATA.IGAUTHORIZATION
      ]
    }
  ],

  [
    'INFRASTRUCTURE',
    {
      name: 'infrastructure',
      icon: 'fa fa-university',
      tourDir: 'left',
      borderTop: '4',
      tools: [
        TOOLS_DATA.IGINFRASTRUCTURE,
        { ...TOOLS_DATA.IGBUSINESS, prefix: 'infrastructure_' },
        TOOLS_DATA.IGAFFILIATION,
        TOOLS_DATA.IGTEAM,
        // TOOLS_DATA.IGBMC,
        TOOLS_DATA.IGBOARD,
        TOOLS_DATA.IGMEETINGS
      ]
    }
  ],
  [
    'EXECUTION',
    {
      name: 'execution',
      icon: 'fa fa-cogs',
      tourDir: 'left',
      borderTop: '3',
      tools: [
        TOOLS_DATA.OUR_TASKS,
        TOOLS_DATA.OUR_SUPPORT
        // TOOLS_DATA.MY_TASKS,
        // TOOLS_DATA.OUR_PRIORITIES
      ]
    }
  ],
  [
    'CUSTOMERS',
    {
      name: 'customers',
      icon: 'fa fa-user',
      tourDir: 'bottom',
      borderTop: '6',
      tools: [
        TOOLS_DATA.IGCUSTOMERS,
        TOOLS_DATA.TOC,
        { ...TOOLS_DATA.IGBUSINESS, prefix: 'customers_' }
      ]
    }
  ],
  [
    'STARTUP',
    {
      name: 'startup',
      icon: 'fa fa-bookmark',
      tourDir: 'top',
      borderTop: '7',
      tools: [
        TOOLS_DATA.IGSTARTUP,
        TOOLS_DATA.IGWEB,
        TOOLS_DATA.PITCH_PREVIEW
        // TOOLS_DATA.STARTUP_EDIT,
        // TOOLS_DATA.IGWEB_EDIT,
        // TOOLS_DATA.PITCH_EDIT,
      ]
    }
  ]
]);

const EXCLUDED_SECTIONS = {};
EXCLUDED_SECTIONS[SECTIONS.EXECUTION] = true;

// const EXCLUDED_TOOLS = {};
// EXCLUDED_TOOLS[TOOLS_DATA.IGWEB_EDIT] = true;
// EXCLUDED_TOOLS[TOOLS_DATA.IGWEB] = true;

const SECTIONS_DATA = new Map();

BASE_SECTIONS_DATA.forEach((val, key) => {
  if (!EXCLUDED_SECTIONS[val.name]) {
    SECTIONS_DATA.set(key, val);
  }
});

export { TOOLS, SECTIONS, SECTIONS_DATA, TOOLS_DATA };
